import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {KeysPipe} from "ngx-pipes";
import {
  AlertController,
  ModalController,
  NavController,
  NavParams,
  PopoverController,
  ToastController,
  ViewController
} from "ionic-angular";
import {PruefpunktAddInfoComponent} from "../pruefpunkt-add-info/pruefpunkt-add-info";
import {ModalNavPage} from "../../pages/modal-nav/modal-nav";
import {DataProvider} from "../../providers/dataprovider/dataprovider";
import 'rxjs/add/operator/debounceTime';
import {AnmerkungstextvorlagenComponent} from "../anmerkungstextvorlagen/anmerkungstextvorlagen";
import {LoadingServiceProvider} from "../../providers/loading-service/loading-service";
import "rxjs/add/operator/debounce";
import "rxjs/add/operator/distinctUntilChanged";
import {Subject} from "rxjs/Subject";
import "rxjs/add/operator/take";
import {GlobalProvider} from "../../providers/global/global";
import {AutoUnsubscribe} from "ngx-auto-unsubscribe";
import {Subscription} from "rxjs/Subscription";
import {LocationService} from "../../store/location/location.service";
import {LocationEntity} from "../../store/location/location.entity";
import {ProtocolService} from "../../store/protocol/protocol.service";
import {ProtocolEntity} from "../../store/protocol/protocol.entity";
import {AuditService} from "../../store/audit/audit.service";


/**
 * Generated class for the ProtokollComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@AutoUnsubscribe()
@Component({
  selector: 'protokoll',
  templateUrl: 'protokoll.html',
  providers: [KeysPipe]
})
export class ProtokollComponent implements OnInit, AfterViewInit, OnChanges, OnDestroy {

  @Input() protokollId: string;
  @Output() changeProtokollId: EventEmitter<any> = new EventEmitter();
  @Input() customerId: string;
  @Input() pruefung: any;
  @Output() protokollDeleted: EventEmitter<any> = new EventEmitter();



  public protokoll: ProtocolEntity;
  public isOwner: boolean = false;
  public isBrowser: boolean = false;
  public standorteContainsSelected: boolean = false;
  public standorte: Array<LocationEntity> = [];

  private _protokollId: Subject<string> = new Subject();
  private _oldValue: any = null;

  private subscriptions: Subscription = new Subscription();

  constructor(private navCtrl: NavController,
              private modalCtrl: ModalController,
              private toastCtrl: ToastController,
              private loadingProvider: LoadingServiceProvider,
              public globalProvider: GlobalProvider,
              private alertCtrl: AlertController,
              private popoverCtrl: PopoverController,
              private locationService: LocationService,
              private protocolService: ProtocolService,
              private auditService: AuditService,
              private ref:ChangeDetectorRef) {
    console.log('Hello ProtokollComponent Component');
    this.isBrowser = this.globalProvider.isBrowser();
  }

  ngOnChanges(changes: SimpleChanges){
    console.dir(changes);
    if(changes.hasOwnProperty('protokollId') && changes.protokollId.currentValue){
      this._protokollId.next(changes.protokollId.currentValue);
    }
  }

  ngOnInit(): void {

    this.subscriptions.add(
      this.locationService.getByCustomerId(this.customerId)
        .subscribe((locations: Array<LocationEntity>) => {
          this.standorte = locations;
        })
    );

    this.subscriptions.add(
      this.protocolService.getById(this.protokollId)
        .takeUntil(this._protokollId)
        .subscribe((protocol: ProtocolEntity) => {
          this.protokoll = protocol;

          for(let standort of this.standorte){
            if(standort.name === this.protokoll.location){
              this.standorteContainsSelected = true;
              break;
            }
          }
          this.isOwner = this.protokoll.ownerId === this.globalProvider.user.uuid;

        })
    );
  }

  ngAfterViewInit(){
    console.log('formcontrolls');
  }

  private _notifyOwnerChanged(): void {
    let alertOwnerchanged = this.alertCtrl.create({
      title: 'Dokument wurde freigegeben',
      subTitle: 'Das Dokument wurde für Sie freigegeben. Sie können es nun bearbeiten.',
      buttons: ['OK']
    });
    alertOwnerchanged.present();
  }

  public setAll(ev: UIEvent): void {

    if(!this.isOwner)
      return;

    let reviews = [];

    this.protokoll.sections.forEach((section) => {
      section.inspectionPoints.forEach((inspectionPoint) => {
        inspectionPoint.reviews.forEach((review) => {

          let found = false;
          for(let i = 0, length = reviews.length; i < length; i++){
            if(JSON.stringify(reviews[i]) === JSON.stringify(review)){
              found = true;
            }
          }
          if(!found){
            reviews.push(review);
          }
        })
      })
    });


    let reviewPopover = this.popoverCtrl.create(ReviewPopoverComponent, {reviews: reviews});
    reviewPopover.onDidDismiss((data) => {
      if(data){

        let toSetStringified = JSON.stringify(data.review)

        this.protokoll.sections.forEach((section) => {
          section.inspectionPoints.forEach((inspectionPoint) => {

            inspectionPoint.reviews.forEach((review) => {
              if(JSON.stringify(review) === toSetStringified || data.review === null){
                inspectionPoint.value = data.review;
              }
            })

          });
        });
        this.save();
      }
    })
    reviewPopover.present({
      ev: ev,
      animate: false
    })

    // this.protokoll.pruefpunkte.forEach((item) => {
    //   item.pruefpunkt.forEach((pruefpunkt) => {
    //     pruefpunkt.value = value;
    //   });
    // });
    //
    // this.protokoll.pruefergebnisse.forEach((ergebnis) => {
    //   switch (ergebnis.propertyName) {
    //     case 'io':
    //     case 'plakette': {
    //       ergebnis.value = true;
    //       break;
    //     }
    //     default: {
    //       ergebnis.value = false;
    //     }
    //   }
    // });
    // this.save();
  };

  public addAdditionalInformation(inspectionPoint: any, sectionName: string): void {
    let modal = this.modalCtrl.create(ModalNavPage, {page: PruefpunktAddInfoComponent, param: {inspectionPoint: inspectionPoint, protocol: this.protokoll, audit: this.pruefung, sectionName: sectionName}});
    modal.onDidDismiss((data) => {
      // pruefpunkt.anmerkungen = data.anmerkungen;
      // pruefpunkt.bilder = data.bilder;
      // this.save();
    })
    modal.present();
  };

  public delete(): void {
    this._protokollId.next();
    this._protokollId.complete();
    this._protokollId.unsubscribe();
    this.protokollDeleted.emit(this.protokoll);
  }

  public save(compareWithOldValue: boolean = false, newValue?: any) {

    if(compareWithOldValue){
      if(this._oldValue == newValue){
        return;
      }
    }

    this.protocolService.set(this.protokoll, false)
      .then((success) => {
        console.log('protokoll erfolgreich upgedated');
      }, (error) => {
        this.toastCtrl.create({
          message: 'Fehler beim Speichern!',
          duration: 1000,
          position: 'bottom'
        }).present();
        console.log('fehler beim updaten des Protokolls');
        console.dir(error);
      })

    // this.dataProvider.updateDocument(this.protokoll)
    //   .then((success) => {
    //     console.log('protokoll erfolgreich upgedated');
    //   }, (error) => {
    //     this.toastCtrl.create({
    //       message: 'Fehler beim Speichern!',
    //       duration: 1000,
    //       position: 'bottom'
    //     }).present();
    //     console.log('fehler beim updaten des Protokolls');
    //     console.dir(error);
    //   })
  }

  public setPruefpunktValue(inspectionPoint: any, ev: UIEvent): void {
    if(!this.isOwner)
      return;


    this.rememberOldValue(inspectionPoint.value);

    let reviewPopover = this.popoverCtrl.create(ReviewPopoverComponent, {reviews: inspectionPoint.reviews});
    reviewPopover.onDidDismiss((data) => {
      if(data){
        inspectionPoint.value = data.review;
        this.save(true, data.review);
      }
    });
    reviewPopover.present({
      ev: ev,
      animate: false
    });

    // p.value = value;
    // this.save();
  }

  public duplicate():void {
    this.loadingProvider.present();
    let _dup = JSON.parse(JSON.stringify(this.protokoll));
    delete _dup._id;
    delete _dup._rev;

    if(_dup.hasOwnProperty('masterData') && _dup.masterData.length > 0){
      _dup.masterData[0].value += ' (Kopie)';
    }

    this.protocolService.add(_dup, false)
      .then((copy) => {
        this.pruefung.protokolle.push(copy._id);
        this.protokollId = copy._id;
        this.protokoll = copy;

        this.auditService.set(this.pruefung, false);
        // this.dataProvider.updateDocument(this.pruefung);

        this.changeProtokollId.emit(copy._id);

        this.loadingProvider.dismiss();
        this.toastCtrl.create({
          message: 'Protokoll erfolgreich dupliziert und geladen',
          duration: 1000,
          position: 'bottom'
        }).present();
      }, (error) => {
        this.loadingProvider.dismiss();
        this.toastCtrl.create({
          message: 'Fehler beim Duplizieren!',
          duration: 1000,
          position: 'bottom'
        }).present();
      })

    // this.dataProvider.createDocumentWithoutInit(_dup)
    //   .then((copy) => {
    //     this.pruefung.protokolle.push(copy._id);
    //     this.protokollId = copy._id;
    //     this.protokoll = copy;
    //     this.dataProvider.updateDocument(this.pruefung);
    //
    //
    //
    //     this.changeProtokollId.emit(copy._id);
    //
    //     this.loadingProvider.dismiss();
    //     this.toastCtrl.create({
    //       message: 'Protokoll erfolgreich dupliziert und geladen',
    //       duration: 1000,
    //       position: 'bottom'
    //     }).present();
    //   }, (error) => {
    //     this.loadingProvider.dismiss();
    //     this.toastCtrl.create({
    //       message: 'Fehler beim Duplizieren!',
    //       duration: 1000,
    //       position: 'bottom'
    //     }).present();
    //   })
  }

  public deleteAnmerkung(comment: string): void {
    this.protokoll.comments = this.protokoll.comments.filter((_comment) => {
      return _comment !== comment;
    });
    this.protocolService.set(this.protokoll, false);
    // this.dataProvider.updateDocument(this.protokoll);
  }

  public addAnmerkung():void {
    this.modalCtrl.create(ModalNavPage, {page: AnmerkungstextvorlagenComponent, param: {rootElement: this.protokoll}})
      .present();
  }

  public scanObjectData(): void {
    //todo: qr-code reader implementieren. gescannten qr-code an remoteDB senden um auch protokolle von anderen usern zu bekommen. stammdaten aus dem gefundenen protokoll in das neue übernehmen.
  }

  public rememberOldValue(value: any){
    this._oldValue = value;
  }

  // If you work with AOT this method must be present, even if empty!
  // Otherwise 'ng build --prod' will optimize away any calls to ngOnDestroy,
  // even if the method is added by the @AutoUnsubscribe decorator
  ngOnDestroy() {
    // You can also do whatever you need here
    this.subscriptions.unsubscribe();
  }
}

@Component({
  template: `
    <ion-list style="margin-bottom: 0px">
      <!--<ion-list-header>Vorlage auswählen</ion-list-header>-->
      <button style="margin-top: 0px; margin-bottom: 0px" ion-button full icon-start text-center [style.background-color]="review.color" (click)="close(review)" *ngFor="let review of reviews">
        <ng-container *ngIf="review.icon">
          <ion-icon style="font-weight: bold; font-size: 45px;" [name]="review.icon"></ion-icon>
        </ng-container>
        <ion-label>
          {{review.title}}
        </ion-label>
      </button>


      <button style="margin-top: 0px; margin-bottom: 0px" ion-button full icon-start text-center (click)="close(null)">
        <ion-icon style="font-weight: bold; font-size: 45px;" name="trash"></ion-icon>
        <ion-label>
          LÖSCHEN
        </ion-label>
      </button>
      
    </ion-list>
  `
})
export class ReviewPopoverComponent {

  public templates: Array<any> = [];
  public reviews: Array<any> = [];

  constructor(public viewCtrl: ViewController,
              private dataProvider: DataProvider,
              private loadingProvider: LoadingServiceProvider,
              private navParams: NavParams) {

    this.reviews = this.navParams.get('reviews');
    console.dir(this.reviews);

  }

  close(review) {
    // this.loadingProvider.present();
    this.viewCtrl.dismiss({review: review}, null, {animate: false});
  }

  // If you work with AOT this method must be present, even if empty!
  // Otherwise 'ng build --prod' will optimize away any calls to ngOnDestroy,
  // even if the method is added by the @AutoUnsubscribe decorator
  ngOnDestroy() {
    // You can also do whatever you need here
  }
}



// WEBPACK FOOTER //
// ./src/components/protokoll/protokoll.ts